import { TComponentType } from '../AppPage2/types'
import { DataTableV2DataRow } from './DataTableV2/types'
import {
  SheetDataTableV2Component,
  SheetFormComponent,
  SheetMdTextComponent,
} from './sheet-components'
import { FormData } from './DataFormComponent/types'
import { JsonFormPropertyV2 } from './FormComponent/types'

export function SheetComponentRenderer({
  contentType,
  contentId,
  isOpen,
  setIsOpen,
  formData,
  actionId,
  onSubmitOverride,
}: {
  contentType: TComponentType
  contentId: string
  isOpen?: boolean
  setIsOpen: (isOpen: boolean) => void
  formData?: DataTableV2DataRow
  actionId?: string
  onSubmitOverride?: (groupId: string, data: FormData, formProperties: JsonFormPropertyV2[]) => void
}) {
  switch (contentType) {
    case 'data-form':
      return (
        <SheetFormComponent
          contentId={contentId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          formData={formData}
          actionId={actionId}
          onSubmitOverride={onSubmitOverride}
        />
      )
    case 'data-table-v2':
      return <SheetDataTableV2Component contentId={contentId} />
    case 'md-text':
      return <SheetMdTextComponent contentId={contentId} formData={formData} />
    default:
      return null
  }
}
